// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import Button, { ButtonVariants } from "@insite/mobius/Button";
import FileUpload from "@insite/mobius/FileUpload";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { DLSectionTitle, SectionContainer } from "@werner/App/Widgets/DesignSystem/DesignSystem.helpers";
import { dummyProductContext } from "@werner/App/Widgets/DesignSystem/DummyData/DummyProduct";
import capitalize from "lodash/capitalize";
import React, { FC } from "react";
import { css } from "styled-components";

const buttonVariants: ButtonVariants[] = ["primary", "secondary", "tertiary"];

interface ButtonsTabStyles {
    gridItem?: GridItemProps;
    buttonsWrapper?: InjectableCss;
}

const buttonsTabStyles: ButtonsTabStyles = {
    gridItem: {
        width: 12,
        css: css`
            flex-wrap: wrap;
            padding-bottom: 40px;
        `,
    },
    buttonsWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-top: 20px;
            flex-wrap: wrap;
            align-items: center;
            gap: 20px;
        `,
    },
};

const styles = buttonsTabStyles;
const ButtonsTab: FC = props => {
    return (
        <SectionContainer>
            {buttonVariants.map(buttonVariant => (
                <GridItem key={buttonVariant} {...styles.gridItem}>
                    <DLSectionTitle>{`${capitalize(buttonVariant)} Button`}</DLSectionTitle>
                    <StyledWrapper {...styles.buttonsWrapper}>
                        <Button sizeVariant="medium" variant={buttonVariant}>
                            {capitalize(buttonVariant)}
                        </Button>
                        <Button disabled sizeVariant="medium" variant={buttonVariant}>
                            {translate("Disabled")}
                        </Button>
                        <Button sizeVariant="small" variant={buttonVariant}>
                            {translate("Small")}
                        </Button>
                        <Button sizeVariant="large" variant={buttonVariant}>
                            {translate("Large")}
                        </Button>
                    </StyledWrapper>
                </GridItem>
            ))}
            <GridItem {...styles.gridItem}>
                {/* <SectionTitle>{translate("Add To Cart Button")}</SectionTitle>
                <StyledWrapper {...styles.buttonsWrapper}> */}
                {/* <ProductContext.Provider value={dummyProductContext}>
                        <ProductAddToCartButton data-test-selector="actionsAddToCart-545454654" />
                    </ProductContext.Provider>
                    <ProductContext.Provider value={dummyProductContext}>
                        <ProductAddToCartButton data-test-selector="actionsAddToCart-545454654" />
                    </ProductContext.Provider> */}
                {/* TODO: if you have customization ProductAddToCartButton variants or style, you can add it here */}
                {/* <ProductContext.Provider value={dummyProductContext}> */}
                {/*    <ProductAddToCartButton data-test-selector="actionsAddToCart-545454654" /> */}
                {/* </ProductContext.Provider> */}
                {/* </StyledWrapper> */}
            </GridItem>
            <GridItem {...styles.gridItem}>
                <DLSectionTitle>{translate("Upload File Button")}</DLSectionTitle>
                <StyledWrapper {...styles.buttonsWrapper}>
                    <StyledWrapper style={{ width: "450px" }}>
                        <FileUpload
                            accept=".xls,.xlsx,.csv"
                            label="Upload a File"
                            labelPosition="top"
                            uid="orderUploadFileUpload"
                        />
                    </StyledWrapper>
                </StyledWrapper>
            </GridItem>
        </SectionContainer>
    );
};

export default ButtonsTab;
